import { render } from "./RequisitesPage.vue?vue&type=template&id=36f6f70c&scoped=true"
import script from "./RequisitesPage.vue?vue&type=script&lang=js"
export * from "./RequisitesPage.vue?vue&type=script&lang=js"

import "./RequisitesPage.vue?vue&type=style&index=0&id=36f6f70c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f6f70c"]])

export default __exports__